import { Route, Routes } from '@solidjs/router';
import { AddMagicTagsPage } from '~/components/magic-tags-v2/AddMagicTagsPage';

export const MagicTagsMobile = () => {
  return (
    <Routes>
      <Route path="/add" component={AddMagicTagsPage} />
    </Routes>
  );
};
